// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Uda","label":"styles_label__29otw"};